export default function RamadanChennaiSEO() {
  return (
    <div className="bg-[#1A1A1A] text-[#E5E7EB] min-h-screen px-6 py-16">
      <div className="max-w-4xl mx-auto space-y-10">

        <h1 className="text-4xl font-bold text-[#D4AF37]">
          Free Sehri & Iftar in Chennai – Ramadan 2026 Guide
        </h1>

        <p className="text-lg text-[#A1A1AA] leading-relaxed">
          Looking for free Sehri in Chennai? Searching for Chennai Sehri time,
          Sehar time, Iftar time, or Roza time in Chennai during Ramadan 2026?
          This platform was created to help students, travelers, hostel residents,
          and anyone in need find Masjids and organizations providing free Sehri
          and Iftar meals across Chennai.
        </p>

        <h2 className="text-2xl font-semibold text-[#D4AF37]">
          Why We Started This Initiative
        </h2>

        <p className="text-[#A1A1AA] leading-relaxed">
          During Ramadan in Chennai, many people search online for
          “Free Sehri in Chennai”, “Sehar near me”, “Iftar time Chennai 2026”,
          and “Roza time Chennai”. While prayer time information is easily available,
          information about Masjids and organizations providing Sehri meals
          is scattered and difficult to find.
        </p>

        <p className="text-[#A1A1AA] leading-relaxed">
          Our mission is simple: connect people in Chennai with Masjids and
          community organizations offering free Sehri and Iftar during Ramadan.
          No one should begin their fast alone because they couldn't find food.
        </p>

        <h2 className="text-2xl font-semibold text-[#D4AF37]">
          What You Can Find Here
        </h2>

        <ul className="list-disc list-inside text-[#A1A1AA] space-y-2">
          <li>Free Sehri providers in Chennai</li>
          <li>Masjids offering Sehar meals</li>
          <li>Iftar meal locations across Chennai</li>
          <li>Ramadan 2026 Roza time Chennai updates</li>
          <li>Sehri and Iftar serving timings</li>
          <li>Contact details for food providers</li>
        </ul>

        <h2 className="text-2xl font-semibold text-[#D4AF37]">
          Ramadan 2026 in Chennai
        </h2>

        <p className="text-[#A1A1AA] leading-relaxed">
          Ramadan 2026 in Chennai is expected to begin in late February
          (subject to moon sighting). During this sacred month,
          Muslims observe Roza (fasting) from Sehri (Suhoor) until Iftar.
          Many search for Chennai Sehri time, Sehar time, and Iftar time daily.
          Along with prayer timings, access to food support is equally important.
        </p>

        <h2 className="text-2xl font-semibold text-[#D4AF37]">
          Help the Community
        </h2>

        <p className="text-[#A1A1AA] leading-relaxed">
          If your Masjid or organization provides free Sehri or Iftar in Chennai,
          we encourage you to register and share correct details.
          This helps students, workers, and travelers searching for
          “Free Sehri in Chennai” or “Sehar near me” find assistance easily.
        </p>

        <p className="text-[#A1A1AA] leading-relaxed">
          Together, we can make Ramadan 2026 in Chennai more connected,
          compassionate, and accessible for everyone.
        </p>

      </div>
    </div>
  );
}
